<div class="wrapper">
  @for (x of config; track x) {
    @if (nestedLayout) {
      <mat-expansion-panel
        hideToggle
        [(expanded)]="x.isExpanded"
        class="section station-section nested"
        >
        <mat-expansion-panel-header>
          <mat-panel-title class="block-heading">
            <div class="header-line-1">
              <div>{{x.heading}}</div>
              <mat-icon
                class="chevron-icon"
                [svgIcon]="x.isExpanded ? 'chevron-up' : 'chevron-down'"
                />
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="section-content">
          @for (y of x.children; track y) {
            <mat-expansion-panel
              hideToggle
              [(expanded)]="y.isExpanded"
              class="time-section"
              >
              <mat-expansion-panel-header>
                <mat-panel-title class="station block-heading">
                  <div class="header-line-1">
                    <div class="child-heading">{{y.heading}}</div>
                    <mat-icon
                      class="chevron-icon"
                      [svgIcon]="y.isExpanded ? 'chevron-up' : 'chevron-down'"
                      />
                  </div>
                  <div class="child-subheading">{{y.subHeading}}</div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <section class="section values-section">
                @for (field of y.fields; track field) {
                  <app-view-field
                    class="value-field"
                    [label]="field.label"
                    [value]="field.value"
                    [hint]="field.hint"
                    [uom]="field.uom"
                    />
                }
              </section>
              @if (y.pictures?.length) {
                <section
                  class="section">
                  <app-attachments-block
                    [pictures]="y.pictures"
                    />
                </section>
              }
            </mat-expansion-panel>
          }
        </div>
      </mat-expansion-panel>
    } @else {
      <mat-expansion-panel
        hideToggle
        [(expanded)]="x.isExpanded"
        class="time-section section"
        >
        <mat-expansion-panel-header>
          <mat-panel-title class="station block-heading">
            <div class="header-line-1">
              <div class="child-heading">{{x.heading}}</div>
              <mat-icon
                class="chevron-icon"
                [svgIcon]="x.isExpanded ? 'chevron-up' : 'chevron-down'"
                />
            </div>
            <div class="child-subheading">{{x.subHeading}}</div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <section class="section values-section">
          @for (field of x.fields; track field) {
            <app-view-field
              class="value-field"
              [label]="field.label"
              [value]="field.value"
              [hint]="field.hint"
              [uom]="field.uom"
              />
          }
        </section>
        @if (x.pictures?.length) {
          <section
            class="section">
            <app-attachments-block
              [pictures]="x.pictures"
              />
          </section>
        }
      </mat-expansion-panel>
    }
  }

</div>
